import Card from '../../../components/base/Card';

export default function MolecularIdentificationSection() {
  const features = [
    {
      icon: 'ri-dna-line',
      title: 'Análise de DNA',
      description: 'Sequenciamento de regiões específicas do genoma para identificação precisa de microrganismos.'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Independente de Cultivo',
      description: 'Identificação direta de organismos mesmo quando não podem ser cultivados em laboratório.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Resultados Rápidos',
      description: 'Identificação em dias, não semanas, acelerando decisões críticas em processos industriais.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Alta Confiabilidade',
      description: 'Precisão superior aos métodos tradicionais, reduzindo erros de identificação.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="animate-fade-in">
            <h2 className="text-4xl font-gilroy font-bold text-crop-black mb-6">
              O que é Identificação Microbiológica Molecular?
            </h2>
            <p className="text-lg font-gilroy text-crop-dark mb-6 leading-relaxed">
              A identificação microbiológica molecular é uma tecnologia avançada que utiliza análise de DNA para identificar microrganismos de forma precisa e rápida, sem depender de métodos tradicionais de cultivo.
            </p>
            <p className="text-lg font-gilroy text-crop-dark mb-8 leading-relaxed">
              Esta metodologia revoluciona o controle de qualidade microbiológico ao fornecer resultados mais confiáveis, rápidos e abrangentes, sendo essencial para indústrias que exigem alta precisão na identificação de contaminantes e microrganismos de interesse.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-crop-teal/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-crop-black"></i>
                </div>
                <div>
                  <h4 className="font-gilroy font-semibold text-crop-black mb-1">Precisão Científica</h4>
                  <p className="font-gilroy text-crop-dark text-sm">Identificação baseada em características genéticas únicas</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-crop-teal/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-crop-black"></i>
                </div>
                <div>
                  <h4 className="font-gilroy font-semibold text-crop-black mb-1">Aplicação Universal</h4>
                  <p className="font-gilroy text-crop-dark text-sm">Eficaz para bactérias, fungos e leveduras</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-crop-teal/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-crop-black"></i>
                </div>
                <div>
                  <h4 className="font-gilroy font-semibold text-crop-black mb-1">Conformidade Regulatória</h4>
                  <p className="font-gilroy text-crop-dark text-sm">Atende exigências de órgãos reguladores internacionais</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="animate-fade-in">
            <div 
              className="relative h-96 rounded-2xl overflow-hidden shadow-xl"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/91b17e0e4c4c5325a19775db74687ed5/947afb227b67a5b0c483acd9e2502dde.jfif')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-crop-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
        
        <div className="mt-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <Card key={index} hover className="animate-fade-in text-center">
                <div className="w-16 h-16 mx-auto bg-crop-teal/20 rounded-full flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-3xl text-crop-black`}></i>
                </div>
                <h3 className="text-lg font-gilroy font-semibold text-crop-black mb-3">
                  {feature.title}
                </h3>
                <p className="font-gilroy text-crop-dark text-sm leading-relaxed">
                  {feature.description}
                </p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}